/** @jsx jsx */

import { ReactNode, Children } from 'react';
import { isNumber, isString } from 'lodash';

import { jsx, css } from '@emotion/core';

type Props = {
  children: ReactNode;
  /** Show as display block? */
  isBlock?: boolean;
  /** HTML title text */
  title?: string;
  /** optional ID for the element */
  id?: string;
};

const truncatedTextCss = (isBlock?: boolean) => css`
  display: ${isBlock ? 'block' : 'inline-block'};
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

/**
 * Truncates text after 100% width an ellipsis
 */
const TruncatedText = ({ children, isBlock = false, title, id }: Props) => {
  const childrenArray = Children.toArray(children);
  const isEveryChildPrimitive = childrenArray.every(
    child => isString(child || '') || isNumber(child)
  );
  const joinedPrimitiveChildren = isEveryChildPrimitive
    ? childrenArray.join(' ')
    : undefined;

  const titleText = title ? title : joinedPrimitiveChildren;

  return (
    <span css={truncatedTextCss(isBlock)} id={id} title={titleText}>
      {children}
    </span>
  );
};

export default TruncatedText;
